import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';
import { MomentInput } from 'moment';

@Pipe({
  name: 'truncateTimeString',
})
export class TruncateTimeStringPipe implements PipeTransform {
  transform(
    value: string,
    format: string = 'minutes',
    leadingZeros: boolean = false,
    divider = ':',
    hoursText = '',
    minutesText = '',
  ): string {
    const parts = value.split(':');

    if (leadingZeros == false) {
      parts[0] = parseInt(parts[0]).toString() + hoursText;
      parts[1] = parseInt(parts[1]).toString() + minutesText;
    }

    if (format === 'minutes') {
      let retval = parts[0];

      if (retval != '') {
        retval += divider;
      }
      retval += parts[1];

      return retval;
    }

    if (format === 'hours') {
      return `${parts[0]}`;
    }
  }
}
